import { createContext } from 'react';

const Context = createContext<any>({});

export default Context;
